import ContentSection from '@/components/ContentSection';
import PageHeader from '@/components/PageHeader';
import LocalizedDate from 'components/LocalizedDate';
import styles from './styles/GameArticle.module.scss';
import ApplicationShareButton from 'containers/ApplicationContainer/components/ApplicationShareButton';

export default function GameArticle({
  date,
  headline,
  paragraphs,
  venue
}: {
  date: string;
  headline: string;
  paragraphs: string[];
  venue?: string;
}) {
  return (
    <ContentSection>
      <div className={styles.Article}>
        <PageHeader>{headline}</PageHeader>
        <div className={styles.Byline}>
          <div>
            SBLive Report, <LocalizedDate date={date} format="MMM D, YYYY" />
          </div>
          <div>
            <ApplicationShareButton />
          </div>
        </div>
        {paragraphs.map((paragraph, i) => (
          <p key={i} dangerouslySetInnerHTML={{ __html: ((i === 0 && venue && `<strong>${venue}</strong> - `) || '') + paragraph }}></p>
        ))}
      </div>
    </ContentSection>
  );
}
